import { rootApi } from "../../api/rootApi";

export const ecommerceOrderApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    // Fetch all ecommerce orders (Listing)
    fetchEcommerceOrders: builder.mutation({
      query: ({ slug, token, ...body }) => ({
        url: `/tenant/ecommerce/order/fetch`,
        method: "POST",
        headers: {
          slug,
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body,
      }),
    }),

    // Fetch order detail by ID
    fetchEcommerceOrderById: builder.mutation({
      query: ({ slug, token, order_id, ...body }) => ({
        url: `/tenant/ecommerce/order/fetch/${order_id}`,
        method: "GET",
        headers: {
          slug,
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      }),
    }),

    // Update ecommerce order
    updateEcommerceOrder: builder.mutation({
      query: ({ slug, token, ...body }) => ({
        url: `/tenant/ecommerce/order/update`,
        method: "POST",
        headers: {
          slug,
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body,
      }),
    }),
    
    // Fetch purchase action logs for an order
    fetchEcommerceOrderLogs: builder.mutation({
      query: ({ slug, token, order_id }) => ({
        url: `/tenant/ecommerce/order/action-logs/${order_id}`,
        method: "GET",
        headers: {
          slug,
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      }),
    }),

    // Report shortfall on an order
    reportEcommerceShortfall: builder.mutation({
      query: ({ slug, token, ...body }) => ({
        url: `/tenant/ecommerce/order/update-shortfall`,
        method: "POST",
        headers: {
          slug,
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body,
      }),
    }),

    // Ship order
    shipEcommerceOrder: builder.mutation({
      query: ({ slug, token, ...body }) => ({
        url: `/tenant/ecommerce/order/ship`,
        method: "POST",
        headers: {
          slug,
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body,
      }),
    }),

    // Deliver order
    deliverEcommerceOrder: builder.mutation({
      query: ({ slug, token, ...body }) => ({
        url: `/tenant/ecommerce/order/deliver`,
        method: "POST",
        headers: {
          slug,
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body,
      }),
    }),

    // Bulk add ecommerce orders
    bulkAddEcommerceOrder: builder.mutation({
      query: ({ slug, token, ...body }) => ({
        url: `/tenant/ecommerce/order/bulk-add`,
        method: "POST",
        headers: {
          slug,
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body,
      }),
    }),
  }),
});

export const {
  useFetchEcommerceOrdersMutation,
  useFetchEcommerceOrderByIdMutation,
  useUpdateEcommerceOrderMutation,
  useFetchEcommerceOrderLogsMutation,
  useReportEcommerceShortfallMutation,
  useShipEcommerceOrderMutation,
  useDeliverEcommerceOrderMutation,
  useBulkAddEcommerceOrderMutation,
} = ecommerceOrderApi;
